import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useSignup from "../../common/hooks/pages/useSignup";
import LoginForm from "../components/LoginForm";
import { setLocalStorage } from "../../common/helpers/browserStorage";
import { useAuth } from "../../common/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function LoginContainer() {
  const { setAccessToken } = useAuth();
  const { toast } = usePopup();

  const navigate = useNavigate();

  const { login } = useSignup();

  const { mutate, isLoading } = useMutation({
    mutationFn: login,
    onSuccess: (res) => {
      const { message, accessToken } = res?.data || {};

      setLocalStorage("accessToken", accessToken);
      setAccessToken(accessToken);

      navigate("/organization");

      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || "Something went wrong while login!";
      toast(message, "error");
    },
  });

  return (
    <LoginForm onSubmit={(data) => mutate(data)} isSubmitting={isLoading} />
  );
}

export default LoginContainer;
